import { Component,ElementRef, ViewChild, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { CommonEventService } from '../services/common-event.service';
import { DomSanitizer,SafeHtml,SafeResourceUrl  } from '@angular/platform-browser';
// import $ from 'jquery';
import { FormsModule,ReactiveFormsModule,FormGroup, FormControl, Validators ,FormBuilder } from '@angular/forms';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';

import { FooterComponent } from '../footer/footer.component';

declare function fpayment(a:any):any;
@Component({
    selector: 'app-order-review',
    templateUrl: './order-review.component.html',
    styleUrls: ['./order-review.component.css'],
    imports: [FooterComponent, FormsModule,ReactiveFormsModule, CommonModule],
    standalone: true
})
export class OrderReviewComponent {
  total_turntime=0;
  total_total=0;
  total_without_shipping=0;
  pcbTotal = 0;
  pcbAssemblyTotal = 0;
  componentTotal = 0;
  pcbTax = 0;
  assemblyTax = 0;
  componentTax = 0;
  orderTotal: any;
  specDetails = [];
  partdata={};
  pcbPartDataSpecs :any =[];
  isHidden = true;
  fabTurnTimeDisplay:any;
  assTurnTimeDisplay:any;
  layerValToDisplay:any;
  pcbSubTotal = 0;
  assemblySubTotal = 0;
  componentSubTotal = 0;
  numOfBomItemsCharging : any;
  savedPartDataIndBoardXDim : any;
  savedPartDataIndBoardYDim : any;
  flowActivityId:any='';
  orderReviewPageEventObj:any={};
  unauthEmailisValid: boolean = false;
  unauthDomain: string = '';
  cardHolderName:any;
  iframeUrl!: SafeResourceUrl;
  isLoading = true;
  cardFieldValidation:any  = {};
  cardValidation: any = {}; 
  paymentSubmitted:any='';
  
  @ViewChild("cardName") cardName!: ElementRef ;
  @ViewChild("ccid") ccid!: ElementRef ;
  @ViewChild("notAuthFirstName") authFistName!: ElementRef;
  @ViewChild("notAuthEmail") authEmail!: ElementRef;
  @ViewChild("notAuthAgreed") authAgreed!: ElementRef;

  constructor(private router: Router, public apiService:ApiService,public commonService : CommonEventService,private sanitizer: DomSanitizer) {
    localStorage.setItem('apiSerDataObj','')
    localStorage.setItem('commonDataObj','')
    localStorage.setItem('apDtId','')
  }
  ngOnInit(): void {
    window.addEventListener(
      'cardValidationUpdated',
      this.handleCardValidation
    );
    window.addEventListener(
      'paymentResponseReceived',
      this.handlePaymentResponse
    );
    window.addEventListener(
      'paymentFailedResponseReceived',
      this.handlePaymentFailedResponse
    );
    fpayment(this.commonService.commonMainObj.userId);
    this.commonService.restrictRefreshButton();
    this.commonService.formattingCurrentDateTime();
    var orderReviewData={
      "pageVisited":"Date:  "+this.commonService.commonMainObj.formattedDate+" " +"Time:"+this.commonService.commonMainObj.formattedTime
    }
    this.flowActivityId = this.commonService.commonMainObj.backToPrevPageActivityId != '' ? this.commonService.commonMainObj.backToPrevPageActivityId:this.commonService.commonMainObj.fileId;
    this.apiService.updateDetailsToDashboard(this.flowActivityId,orderReviewData,'ReviewConfirmOrderPage').subscribe((resDatas)=>{
    // console.log("updateDetailsToDashboard",resDatails);
    })
    this.total_total=0;
    this.total_without_shipping = 0;
    this.total_turntime = 0;
    if(this.commonService.commonMainObj.selectedLayerVal > 1 ){
      this.layerValToDisplay = this.commonService.commonMainObj.selectedLayerVal  + ' Layers';
    }else{
      this.layerValToDisplay = this.commonService.commonMainObj.selectedLayerVal  + ' Layer';
    } 
    this.savedPartDataIndBoardXDim = this.commonService.commonMainObj.indBoardXDim > this.commonService.commonMainObj.indBoardYDim ? this.commonService.commonMainObj.indBoardXDim :this.commonService.commonMainObj.indBoardYDim;
    this.savedPartDataIndBoardYDim = this.commonService.commonMainObj.indBoardXDim < this.commonService.commonMainObj.indBoardYDim ? this.commonService.commonMainObj.indBoardXDim :this.commonService.commonMainObj.indBoardYDim;
    this.commonService.commonMainObj.savedBoardDimensions = this.savedPartDataIndBoardXDim +' x '+this.savedPartDataIndBoardYDim+'(inches)';

    if(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems){
      for(var i=0; i < this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems.length; i++){
        if( this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[i].quantity!=null && this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[i].unitPrice!=null ){
          this.total_total +=  ( this.to_Num(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[i].quantity) * this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[i].unitPrice));
          this.total_without_shipping +=  ( this.to_Num(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[i].quantity) * this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[i].unitPrice));
          
          if ( this.commonService.commonMainObj.electricalTesting=="No" ){ 

          }else {
            this.total_total += this.to_Float( this.commonService.commonMainObj.electricalTestingPriceVal );
            this.total_without_shipping += this.to_Float( this.commonService.commonMainObj.electricalTestingPriceVal );
          }
        }
        if(this.commonService.commonMainObj.taxablePrice){
          this.total_total += this.to_Float(this.commonService.commonMainObj.taxablePrice);
          this.total_without_shipping += this.to_Float(this.commonService.commonMainObj.taxablePrice);
        }
      }
      if (this.commonService.commonMainObj.shippingCost!=null && this.commonService.commonMainObj.shippingCost!=""){
        this.total_total += this.to_Float( this.commonService.commonMainObj.shippingCost );
      }
      this.total_total =  this.to_Float(  this.total_total.toFixed(2) );
    }
    if(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems){
      let Total = 0;
      if(this.commonService.commonMainObj.taxableRate != null && this.commonService.commonMainObj.taxableRate != ""){
        this.pcbTax = (this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].subTotal) - this.to_Float(this.commonService.commonMainObj.pcbPromoDiscount ? this.commonService.commonMainObj.pcbPromoDiscount : 0.0)) * this.to_Float(this.commonService.commonMainObj.taxableRate) / 100;
      }else{
        this.pcbTax = 0.00;
      }
      this.total_turntime+=this.to_Num( this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].turntime );
      this.pcbSubTotal = (this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].subTotal) - this.to_Float(this.commonService.commonMainObj.pcbPromoDiscount ? this.commonService.commonMainObj.pcbPromoDiscount : 0.0));
      this.pcbTotal = (this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].subTotal) - this.to_Float(this.commonService.commonMainObj.pcbPromoDiscount ? this.commonService.commonMainObj.pcbPromoDiscount : 0.0)) + this.to_Float(this.pcbTax);
      // console.log("this.pcbTax ",this.pcbTax );
      this.pcbTotal = parseFloat(this.pcbTotal.toFixed(2));
      // console.log("this.pcbTotal",this.pcbTotal);
      if(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems.length > 1){
        if(this.commonService.commonMainObj.taxableRate != null && this.commonService.commonMainObj.taxableRate != ""){
          this.assemblyTax = (this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].subTotal) - this.to_Float(this.commonService.commonMainObj.assemblyPromoDiscount ? this.commonService.commonMainObj.assemblyPromoDiscount : 0.0)) * this.to_Float(this.commonService.commonMainObj.taxableRate) / 100;
        }else{
          this.assemblyTax = 0.00;
        }
        this.total_turntime+=this.to_Num( this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].turntime );
        this.assemblySubTotal = (this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].subTotal) - this.to_Float(this.commonService.commonMainObj.assemblyPromoDiscount ? this.commonService.commonMainObj.assemblyPromoDiscount : 0.0));
        this.pcbAssemblyTotal = (this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].subTotal) - this.to_Float(this.commonService.commonMainObj.assemblyPromoDiscount ? this.commonService.commonMainObj.assemblyPromoDiscount : 0.0)) + this.to_Float(this.assemblyTax);
        this.pcbAssemblyTotal = parseFloat(this.pcbAssemblyTotal.toFixed(2));
        
        if(this.commonService.commonMainObj.taxableRate != null && this.commonService.commonMainObj.taxableRate != ""){
          this.componentTax = (this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].subTotal) - this.to_Float(this.commonService.commonMainObj.componentPromoDiscount ? this.commonService.commonMainObj.componentPromoDiscount : 0.0)) * this.to_Float(this.commonService.commonMainObj.taxableRate) / 100;
        }else{
          //IF THERE IS NO TAX PRICE THEN SUB-TOTAL IS THE componentTotal
          this.componentTotal = this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].subTotal);
        }
        this.componentTotal = (this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].subTotal) - this.to_Float(this.commonService.commonMainObj.componentPromoDiscount ? this.commonService.commonMainObj.componentPromoDiscount : 0.0)) + this.to_Float(this.componentTax);
        this.componentSubTotal = (this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].subTotal) - this.to_Float(this.commonService.commonMainObj.componentPromoDiscount ? this.commonService.commonMainObj.componentPromoDiscount : 0.0))

        this.componentTotal = parseFloat(this.componentTotal.toFixed(2));
        this.componentSubTotal = parseFloat(this.componentSubTotal.toFixed(2));
      }
      //Checking the order is PCB+Assembly or only PCB BASED ON THAT CALCULATING THE TOTAL
      if(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems.length > 1){
        Total = this.pcbTotal + this.pcbAssemblyTotal + this.componentTotal - this.to_Float(this.commonService.commonMainObj.shippingPromoDiscount && !this.commonService.commonMainObj.shippingAccountNumber ? this.commonService.commonMainObj.shippingPromoDiscount : 0.0);
      }else{
        Total = this.pcbTotal  - this.to_Float(this.commonService.commonMainObj.shippingPromoDiscount && !this.commonService.commonMainObj.shippingAccountNumber ? this.commonService.commonMainObj.shippingPromoDiscount : 0.0);
      }
      if(this.commonService.commonMainObj.shippingCost != null && this.commonService.commonMainObj.shippingCost != ""){
        this.orderTotal = Total + this.to_Float(this.commonService.commonMainObj.shippingCost);
        this.orderTotal = parseFloat(this.orderTotal.toFixed(2));

        // this.orderTotal = Math.floor((Total + this.to_Float(this.commonService.commonMainObj.shippingCost)) * 100) / 100;
      }else{
        this.orderTotal = parseFloat(Total.toFixed(2));
        // this.orderTotal = Math.floor(Total * 100) / 100;
      }
      this.commonService.commonMainObj.orderPlacedData.orderTotal = this.orderTotal;
    }
    var qinput:any ={};
    for(var k in this.commonService.commonMainObj.pcbPartData['products']){
      for(var k1 in this.commonService.commonMainObj.pcbPartData['products'][k]['quoteInputGroups']){
        for(var k2 in this.commonService.commonMainObj.pcbPartData['products'][k]['quoteInputGroups'][k1]['quoteInputs']){
          if (qinput[this.commonService.commonMainObj.pcbPartData['products'][k]['quoteInputGroups'][k1]['quoteInputs'][k2]['inputName']] == undefined) {
            qinput[this.commonService.commonMainObj.pcbPartData['products'][k]['quoteInputGroups'][k1]['quoteInputs'][k2]['inputName']] = [];
            qinput[this.commonService.commonMainObj.pcbPartData['products'][k]['quoteInputGroups'][k1]['quoteInputs'][k2]['inputName']].push({'iName': this.commonService.commonMainObj.pcbPartData['products'][k]['quoteInputGroups'][k1]['quoteInputs'][k2]['inputName'],'dName': this.commonService.commonMainObj.pcbPartData['products'][k]['quoteInputGroups'][k1]['quoteInputs'][k2]['displayName']});
          }
        }
      }
    }
    // console.log("qinput",qinput);
    // console.log("this.commonService.commonMainObj.pcbFinalQuotedata",this.commonService.commonMainObj.pcbFinalQuotedata);
    var dataValue;
    let keysToBeRemoved = ["counterBore","counterSink","edgePlating","controlledDielectric","electricalTesting"];
    let finalSavedPcbPartData = this.DeleteMyKeys(this.commonService.commonMainObj.pcbFinalQuotedata.savedPcbPartData,keysToBeRemoved);
    // console.log("finalSavedPcbPartData",finalSavedPcbPartData);
    for(var t in this.commonService.commonMainObj.pcbFinalQuotedata.savedPcbPartData){
      for(var qi in qinput){
        for(var pd in qinput[qi]){
          if (qinput[qi][pd]['iName'] == t) {
            if(this.commonService.commonMainObj.pcbFinalQuotedata.savedPcbPartData[t] == null){
              dataValue = "-";
            }else{
              dataValue = this.commonService.commonMainObj.pcbFinalQuotedata.savedPcbPartData[t];
            }
            if(qinput[qi][pd]['dName'] == "Min. Hole Size"){
              dataValue  = this.commonService.commonMainObj.minHoleSizeSelected;
            }
            if(qinput[qi][pd]['dName'] == "Surface Finish"){
              dataValue  = this.commonService.commonMainObj.surfaceFinish;
            }
            if(qinput[qi][pd]['dName'] == "Min. Space"){
              dataValue  = this.commonService.commonMainObj.minSpaceSelected;
            }
            if(qinput[qi][pd]['dName'] == "Min. Trace"){
              dataValue  = this.commonService.commonMainObj.minTraceSelected;
            }
            if(qinput[qi][pd]['dName'] == "Inner layer Min. Space"){
              dataValue  = this.commonService.commonMainObj.minInnerSpaceSelected?this.commonService.commonMainObj.minInnerSpaceSelected:'' ;
            }
            if(qinput[qi][pd]['dName'] == "Inner layer Min. Trace"){
              dataValue  = this.commonService.commonMainObj.minInnerTraceSelected?this.commonService.commonMainObj.minInnerTraceSelected:'';
            }
            if(qinput[qi][pd]['dName'] == "Allow RoHS Marking"){
              dataValue  = this.commonService.commonMainObj.boardDetailsDataObj.roHSMarking;
            }
            if(qinput[qi][pd]['iName'] == "indBoardXDim"){
              qinput[qi][pd]['dName'] = "Individual Board Dimension X (inches)";
            }
            if(qinput[qi][pd]['iName'] == "indBoardYDim"){
              qinput[qi][pd]['dName'] = "Individual Board Dimension Y (inches)";
            }
            if(qinput[qi][pd]['iName'] == "arrayXDim"){
              qinput[qi][pd]['dName'] = "Array Dimension X (inches)";
            }
            if(qinput[qi][pd]['iName'] == "arrayYDim"){
              qinput[qi][pd]['dName'] = "Array Dimension Y (inches)";
            }
            if(qinput[qi][pd]['iName'] == "silkScreenSides"){
              qinput[qi][pd]['dName'] = "Silk Screen Sides";
              dataValue  = this.commonService.commonMainObj.boardDetailsDataObj.silkScreenSides?this.commonService.commonMainObj.boardDetailsDataObj.silkScreenSides:'-';
            }
            if(qinput[qi][pd]['iName'] == "silkScreenColor"){
              qinput[qi][pd]['dName'] = "Silk Screen Color";
              dataValue  = this.commonService.commonMainObj.boardDetailsDataObj.silkScreenColor?this.commonService.commonMainObj.boardDetailsDataObj.silkScreenColor:'-';
            }
            if(qinput[qi][pd]['iName'] == "solderMaskColor"){
              qinput[qi][pd]['dName'] = "Solder Mask Color";
              dataValue  = this.commonService.commonMainObj.boardDetailsDataObj.solderMaskColor?this.commonService.commonMainObj.boardDetailsDataObj.solderMaskColor:'-';
            }
            if(qinput[qi][pd]['iName'] == "solderMaskFinish"){
              qinput[qi][pd]['dName'] = "Solder Mask Finish";
              dataValue  = this.commonService.commonMainObj.boardDetailsDataObj.solderMaskFinish?this.commonService.commonMainObj.boardDetailsDataObj.solderMaskFinish:'-';
            }
            if(qinput[qi][pd]['iName'] == "solderMaskSides"){
              qinput[qi][pd]['dName'] = "Solder Mask Sides";
              dataValue  = this.commonService.commonMainObj.boardDetailsDataObj.solderMaskSides?this.commonService.commonMainObj.boardDetailsDataObj.solderMaskSides:'-';
            }
            if(qinput[qi][pd]['iName'] == "solderMaskType"){
              qinput[qi][pd]['dName'] = "Solder Mask Type";
              dataValue  = this.commonService.commonMainObj.boardDetailsDataObj.solderMaskType?this.commonService.commonMainObj.boardDetailsDataObj.solderMaskType:'-';
            }
            this.pcbPartDataSpecs.push({'dname': qinput[qi][pd]['dName'],'sname': t,'value': dataValue})
            if(this.pcbPartDataSpecs.length == 1){
              if(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].turntime > 1){
                this.pcbPartDataSpecs.push({'dname':'PCB turn-time','value':this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].turntime + ' Day(s)'})
              }else{
                this.pcbPartDataSpecs.push({'dname':'PCB turn-time','value':this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].turntime + ' Day'})
              }
             
            }
            if(this.pcbPartDataSpecs.length == 26){
              this.pcbPartDataSpecs.push({'dname':'Solder Mask Sides','value':this.commonService.commonMainObj.boardDetailsDataObj.solderMaskSides?this.commonService.commonMainObj.boardDetailsDataObj.solderMaskSides:'-'})
            }
            if(this.commonService.commonMainObj.boardDetailsDataObj.innerLyrFinishCopper){
              if(this.pcbPartDataSpecs.length == 17){
                this.pcbPartDataSpecs.push({'dname':'Inner layer Copper Weight','value':this.commonService.commonMainObj.boardDetailsDataObj.innerLyrFinishCopper})
              }
            }
            // if(this.pcbPartDataSpecs.length == 34){
            //   this.pcbPartDataSpecs.push({'dname':'Silk Screen Method','value':this.commonService.commonMainObj.boardDetailsDataObj.silkScreen?this.commonService.commonMainObj.boardDetailsDataObj.silkScreenMethod:'-'})
            // }
           
           
          }
        }
      }
    }
    this.pcbPartDataSpecs.push({'dname':'Controlled impedance','value':this.commonService.commonMainObj.boardDetailsDataObj.controlledImpedance});
    this.pcbPartDataSpecs.push({'dname':'Internal Slots or Internal Cutouts?','value':this.commonService.commonMainObj.boardDetailsDataObj.slotsCutouts})
    if(this.commonService.commonMainObj.fileUploadedData.boardParam.counterSink == 'Yes'){
      this.pcbPartDataSpecs.push({'dname':'Counter Sink','value':this.commonService.commonMainObj.boardDetailsDataObj.counterSink});
    }
    if(this.commonService.commonMainObj.fileUploadedData.boardParam_fast_pcb.counter_bore == 'Yes'){
      this.pcbPartDataSpecs.push({'dname':'Counter Bore','value':this.commonService.commonMainObj.boardDetailsDataObj.counterBore});
    }
    if(this.commonService.commonMainObj.fileUploadedData.boardParam_fast_pcb.controlled_dielectric == 'Yes'){
      this.pcbPartDataSpecs.push({'dname':'Controlled Dielectric','value':this.commonService.commonMainObj.boardDetailsDataObj.controlledDielectric});
    }
    if(this.commonService.commonMainObj.itarConditionCheck == true){
      this.pcbPartDataSpecs.push({'dname':'USML/ECCN','value':this.commonService.commonMainObj.boardDetailsDataObj.usmlOrEccn});
      this.pcbPartDataSpecs.push({'dname':'End Use of PCB/Assembly','value':this.commonService.commonMainObj.boardDetailsDataObj.endUseOfPcbOrAssembly});
    }
    // console.log("pcbSpecs",this.pcbPartDataSpecs);

    if(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].turntime  > 1){
      this.fabTurnTimeDisplay = this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].turntime + ' Days';
    }else{
      this.fabTurnTimeDisplay = this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].turntime + ' Day';
    }
    if(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1]){
      if(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].turntime  > 1){
        this.assTurnTimeDisplay = this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].turntime + ' Days';
      }else{
        this.assTurnTimeDisplay = this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].turntime + ' Day';
      }
      this.commonService.commonMainObj.assemblySides = this.commonService.commonMainObj.assemblySides == '1 side'?'One side':'Two sides';
    }

    this.numOfBomItemsCharging = this.commonService.commonMainObj.finalBomDataToPurchase?.okayToBuy?.title.split(' ')[3];
      
    this.commonService.restrictBrowserButtons();
  
  }
  
  handleCardValidation = (event: Event) => {
    const customEvent = event as CustomEvent;
    const field = customEvent.detail.field;
    const validation = customEvent.detail.validation;
    this.cardValidation[field] = validation;
  };

  handlePaymentResponse = (event: Event) => {
    const customEvent = event as CustomEvent;
    const submitPayment = customEvent.detail.submitPayment;
    console.log("pay submit:", submitPayment);
    this.paymentSubmitted = submitPayment;
    if(this.paymentSubmitted == 'Approved'){
      this.router.navigateByUrl('/orderstatus');
    }else{
      this.apiService.getPendingPaymentMessage(this.commonService.commonMainObj.orderPlacedData.orderNumber).subscribe((data:any)=>{
        if(data){
          this.commonService.commonMainObj.pendingPaymentMessage= data;
          this.commonService.commonMainObj.purchasingPersonDetails.firstName = this.apiService.apiMainObj.selectedBillingAddress.firstName;
          this.commonService.commonMainObj.purchasingPersonDetails.lastName = this.apiService.apiMainObj.selectedBillingAddress.lastName;
          this.commonService.commonMainObj.purchasingPersonDetails.email = this.apiService.apiMainObj.selectedBillingAddress.email;
          this.router.navigateByUrl('/orderstatus');
        }
      });

    }
    
  };

  handlePaymentFailedResponse=(event:Event) => {
    const customEvent = event as CustomEvent;
    if(customEvent.detail.creditCardPayment == 'Service Unavailable'){
      this.commonService.commonMainObj.isNotAuthChecked = true;
      this.commonService.commonMainObj.paymentserviceAvailable =false;
      this.commonService.commonMainObj.hidePaymentSection = true;
      this.notAuthSelection('');
    }
  };

   paymentForm = new FormGroup({
    // cardType:['', Validators.required],
    nameOnCard:new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(99), Validators.pattern('^[a-zA-Z ]*$')]),
  });

  unAuthorizedForm = new FormGroup({
    // cardType:['', Validators.required],
    unAuthFirstName:new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(99), Validators.pattern('^[a-zA-Z ]*$')]),
    unAuthLasttName:new FormControl('', [Validators.minLength(3), Validators.maxLength(99), Validators.pattern('^[a-zA-Z ]*$')]),
    unAuthEmail:new FormControl('', [Validators.required, Validators.email, Validators.minLength(4), Validators.pattern(/^(?!\.)(?!.*\.\.)[a-zA-Z0-9_.-]{1,64}(?<!\.)@(?!(?:.*-[0-9]+\.){2,})(?=[a-zA-Z0-9-]{1,61}\.)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,63}$/)]),
    unAuthRemark:new FormControl('', [Validators.minLength(0), Validators.maxLength(1000)]),
    unAuthAgree: new FormControl('', [Validators.required]),
  });
  validateUnauthDomain(email:any): void {
    this.unauthDomain = this.commonService.commonMainObj.purchasingPersonDetails.email;
    this.commonService.validateDomain(email);
    setTimeout(() => {
      this.unauthEmailisValid = this.commonService.commonMainObj.invalidEmail;
    }, 100);
  }
  payment_validation_messages = {
    'nameOnCard': [
      { type: 'required', message: 'Name is required.' },
      { type: 'minlength', message: 'Name must be at least 3 characters long.' },
      { type: 'maxlength', message: 'Name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Name must contain only letters.' }
    ]
  }
  not_auth_validation_messages = {
    'unAuthFirstName': [
      { type: 'required', message: 'Name is required.' },
      { type: 'minlength', message: 'Name must be at least 3 characters long.' },
      { type: 'maxlength', message: 'Name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Name must contain only letters.' }
    ],
    'unAuthLasttName': [
      { type: 'required', message: '' },
      //{ type: 'minlength', message: 'Name must be at least 3 characters long.' },
      { type: 'maxlength', message: 'Name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Name must contain only letters.' }
    ],
    'unAuthEmail': [
      { type: 'required', message: 'email is required.' },
      { type: 'minlength', message: 'email must be at least 4 characters long.' },
      { type: 'maxlength', message: 'email cannot be more than 25 characters long.' },
      { type: 'pattern', message: 'Please enter a valid email.' }
    ],
    'unAuthRemark': [
      // { type: 'required', message: 'Please fill Remarks' },
    ],
    'unAuthAgree': [
      { type: 'required', message: 'Please agree.' },
    ],
  }
  ngOnDestroy() {
    this.commonService.destroyRefreshEvent();
  }
  
  @HostListener('window:beforeunload', ['$event'])
    onBeforeUnload(event: BeforeUnloadEvent) {
      const perfEntries :any = performance.getEntriesByType("navigation");
      this.commonService.formattingCurrentDateTime();
      if (perfEntries.length > 0 && perfEntries[0].type === "reload") {
        console.log("Page was refreshed");
      }else{
        console.log("Likely tab close");
        this.orderReviewPageEventObj ={
          sourceApp: 'oneflow',
          eventType: 'FinalQuote',
          emailAddress: this.commonService.commonMainObj.boardDetailsDataObj.email ? this.commonService.commonMainObj.boardDetailsDataObj.email:'',
          triggerDate:this.commonService.commonMainObj.formattedDate +'-'+this.commonService.commonMainObj.capturedEventTime,
          createdAt:this.commonService.commonMainObj.capturedEventCreatedAt
        }
        const blob = new Blob([JSON.stringify(this.orderReviewPageEventObj)], {
          type: 'application/json'
        });
        if(!this.commonService.commonMainObj.logoClicked){
          this.apiService.callAPIToSendCapturedEvent(blob);
        }
      }
      // OFP-2560 dashboard
      this.apiService.updateSessionTimeSpent(this.flowActivityId,'OrderDetailsPage');
      console.log("checkk");
      //  event.preventDefault();
      //  event.returnValue = false;
    }

  specDetailsHide(){
    return this.isHidden = !this.isHidden
  }

  // checkSessionPlaceOrder(){
  //   if(this.apiService.encUrlData != localStorage.getItem('encData')){
  //     this.commonService.alertCall('Alert!!','Your session is expired please login and do the flow from starting');
  //     this.commonService.goBack();
  //   }else{
  //     this.apiService.getUserDataSession(this.apiService.encUrlData).subscribe((resData: any)=>{
  //       if(resData && resData.status == "SESSION_FOUND"){
  //         this.goToStatusPage();
  //       }else{
  //         this.commonService.alertCall('Alert!!','Your session is expired please login and do the flow from starting');
  //         this.commonService.goBack();
  //       }
  //     },err=>{
  //       this.commonService.alertCall('Alert!!','Something went wrong');
  //     });
  //   }
    
  // }
  DeleteMyKeys(myObj:any, array:any){
    for (let index = 0; index < array.length; index++) {
      delete myObj[array[index]];
  }
  return myObj;
  }

  goToStatusPage(){
    this.commonService.sessionPortalLoad();
    this.commonService.loadingShow();
    setTimeout(()=>{
      this.commonService.sessionPortalLoad();
      this.commonService.loadingHide();
      this.apiService.checkUserSessionApi().subscribe((data: any)=>{
        if(data.status == 1){
          this.goToStatusPageSessionChecked();
        }
      },error =>{
        console.log('Error in checking user session', error);   
      })
    },2000);
  }

  alertCall(title:any,message:any){
    Swal.fire({
      toast: false,
      showConfirmButton: true,
      showCancelButton: false,
      showCloseButton: true,
       allowOutsideClick: false,
      title:title,
      html:message,
      confirmButtonText: 'Ok'
    });
  }

  goToStatusPageSessionChecked(){
    let message = "";
    if(!this.commonService.commonMainObj.isNotAuthChecked){
      const MAX_FP_SESSION_AGE = 25 * 60 * 1000;//25 min safety buffer instead of 30min.
      const sessionInput  = document.getElementById('fpSessionCreatedAt') as HTMLInputElement; 
      const fpSessionCreatedAt = Number(sessionInput.value.trim());
      const sessionAge = Date.now() - fpSessionCreatedAt;
      if(sessionAge > MAX_FP_SESSION_AGE) {
          this.alertCall('Alert!!',"Your payment session expired due to inactivity. Please re-enter your card details to complete the payment.");
          fpayment(this.commonService.commonMainObj.userId);
          // iframeReloadControls();
          return false;
      }
      if(!this.commonService.commonMainObj.cardHolderName){
        $('#cardName').addClass('border-red');
        this.cardName.nativeElement.focus();
        this.alertCall('Alert!!','Card holder name is required.');
        return;
      }else{
        let km = new RegExp(/^[a-zA-Z ]+$/)
        if(km.test(this.commonService.commonMainObj.cardHolderName) == false){
          this.cardName.nativeElement.focus();
          this.alertCall('Alert!!','Card holder name must be in alphabet.');
          return;
        }
      }
      const cardNumber = this.cardValidation['CardNumber'];
      const expiry = this.cardValidation['ExpirationDate'];
      const cvv = this.cardValidation['SecurityCode'];
      if(cardNumber == undefined || cardNumber == null){
        this.alertCall('Alert!!','Please enter the Card Number');
        return;
      }else if(cardNumber?.isValid === false){
        if(cardNumber.message){
          this.alertCall('Alert!!',cardNumber.message);
          return;
        }
      }
      if(expiry == undefined || expiry == null){
        this.alertCall('Alert!!','Please enter the Expiration Date');
        return;
      }else if(expiry?.isValid === false){
        if(expiry.message){
          this.alertCall('Alert!!',expiry.message);
          return;
        }
      }
      if(cvv == undefined || cvv == null){
        this.alertCall('Alert!!','Please enter the Security Code');
        return;
      }else if(cvv?.isValid === false){
        if(cvv.message){
          this.alertCall('Alert!!',cvv.message);
          return;
        }
      }
    
    }else{
      if(this.commonService.commonMainObj.purchasingPersonDetails.firstName == "" || this.commonService.commonMainObj.purchasingPersonDetails.firstName == undefined ){
        this.authFistName.nativeElement.focus();
        message = "Please enter purchasing person Name";
      }
      if(this.commonService.commonMainObj.purchasingPersonDetails.email == "" || this.commonService.commonMainObj.purchasingPersonDetails.email == undefined){
        message = "Please enter purchasing person email";
        this.authEmail.nativeElement.focus();
      }else if((!/^(?!\.)(?!.*\.\.)[a-zA-Z0-9_.-]{1,64}(?<!\.)@(?!(?:.*-[0-9]+\.){2,})(?=[a-zA-Z0-9-]{1,61}\.)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,63}$/.test(this.commonService.commonMainObj.purchasingPersonDetails.email)) ){
        message = "Please enter valid purchasing person email";
        this.authEmail.nativeElement.focus();
      }
      if(!this.commonService.commonMainObj.purchasingPersonDetails.paymentPending){
        $('.agree-check').addClass('red-brd');
        message = "Please agree the pending payment terms.";
      }
    }
    if(message){
        Swal.fire({
          title: 'Required fields should not be empty',
          text: message,
          //icon: 'warning',
          showCloseButton: true,
          confirmButtonText: 'Ok'
        }).then((result) => {
          if (result['isConfirmed']){
            return
          }
        })
    }else {
      this.commonService.issuesListObjFn();
      var placeOrderObj:any = {}
      placeOrderObj.placeOrder = {
        "areComponentCanNotWashed": this.commonService.commonMainObj.aqueousSelectOption =="Yes"?'1736':'1737',
        "billingAddressLine1": this.apiService.apiMainObj.selectedBillingAddress.addressLine1,
        "billingAddressLine2": this.apiService.apiMainObj.selectedBillingAddress.addressLine2?this.apiService.apiMainObj.selectedBillingAddress.addressLine2:'',
        "billingCity": this.apiService.apiMainObj.selectedBillingAddress.city,
        "billingContactCompany": this.apiService.apiMainObj.selectedBillingAddress.companyName?this.apiService.apiMainObj.selectedBillingAddress.companyName:'',
        "billingContactEmail": this.apiService.apiMainObj.selectedBillingAddress.email?this.apiService.apiMainObj.selectedBillingAddress.email:'',
        "billingContactFirstName": this.apiService.apiMainObj.selectedBillingAddress.firstName?this.apiService.apiMainObj.selectedBillingAddress.firstName:'',
        "billingContactLastName": this.apiService.apiMainObj.selectedBillingAddress.lastName?this.apiService.apiMainObj.selectedBillingAddress.lastName:'',
        "billingContactPhone": this.apiService.apiMainObj.selectedBillingAddress.phoneNumber?this.apiService.apiMainObj.selectedBillingAddress.phoneNumber:'',
        "billingCountry": this.apiService.apiMainObj.selectedBillingAddress.country?this.apiService.apiMainObj.selectedBillingAddress.country:'',
        "billingState": this.apiService.apiMainObj.selectedBillingAddress.state?this.apiService.apiMainObj.selectedBillingAddress.state:'',
        "billingZip": this.apiService.apiMainObj.selectedBillingAddress.zip?this.apiService.apiMainObj.selectedBillingAddress.zip:'',
        "bomSpecialInstructions": "No",
        "channelOrderNumber": "301",
        "contactPersonName24Hour": "",
        "contactPhoneNumber24Hour": "",
        "customerEmail": this.commonService.commonMainObj.email,
        "designFileName": this.commonService.commonMainObj.uploadedFilesData.filename,
        "designerAddressLine1": this.apiService.apiMainObj.selectedDesignerAddress.addressLine1,
        "designerAddressLine2": this.apiService.apiMainObj.selectedDesignerAddress.addressLine2?this.apiService.apiMainObj.selectedDesignerAddress.addressLine2:'',
        "designerCity": this.apiService.apiMainObj.selectedDesignerAddress.city?this.apiService.apiMainObj.selectedDesignerAddress.city:'',
        "designerContactCompany":this.apiService.apiMainObj.selectedDesignerAddress.companyName?this.apiService.apiMainObj.selectedDesignerAddress.companyName:'',
        "designerContactEmail": this.apiService.apiMainObj.selectedDesignerAddress.email?this.apiService.apiMainObj.selectedDesignerAddress.email:'',
        "designerContactFirstName":this.apiService.apiMainObj.selectedDesignerAddress.firstName?this.apiService.apiMainObj.selectedDesignerAddress.firstName:'',
        "designerContactLastName": this.apiService.apiMainObj.selectedDesignerAddress.lastName?this.apiService.apiMainObj.selectedDesignerAddress.lastName:'',
        "designerContactPhone": this.apiService.apiMainObj.selectedDesignerAddress.phoneNumber?this.apiService.apiMainObj.selectedDesignerAddress.phoneNumber:'',
        "designerCountry": this.apiService.apiMainObj.selectedDesignerAddress.country?this.apiService.apiMainObj.selectedDesignerAddress.country:'',
        "designerState": this.apiService.apiMainObj.selectedDesignerAddress.state?this.apiService.apiMainObj.selectedDesignerAddress.state:'',
        "designerZip": this.apiService.apiMainObj.selectedDesignerAddress.zip?this.apiService.apiMainObj.selectedDesignerAddress.zip:'',
        "isElectricalTest":this.commonService.commonMainObj.electricalTesting == "Yes"?'Y':'N',
        "iwillSupplyPcbAs": "0",
        "pcbComingFrom": "0",
        "pcbReceiveDate": "",
        "projectID": "",
        "promoCode": this.commonService.commonMainObj.promoCode != '' ? this.commonService.commonMainObj.promoCode:"",
        "referencePONumber": "",
        "resaleFileByteArray": "",
        "resaleFileName": "",
        "resaleNumber":this.commonService.commonMainObj.isNotAuthChecked?'':this.commonService.commonMainObj.resaleNumber,
        "shipAssembledBoard": "",
        "shippingAccountNumber": this.commonService.commonMainObj.shippingAccountNumber?this.commonService.commonMainObj.shippingAccountNumber:'',
        "shippingAddressLine1": this.apiService.apiMainObj.selectedShippingAddress.addressLine1?this.apiService.apiMainObj.selectedShippingAddress.addressLine1:'',
        "shippingAddressLine2": this.apiService.apiMainObj.selectedShippingAddress.addressLine2?this.apiService.apiMainObj.selectedShippingAddress.addressLine2:'',
        "shippingCity": this.apiService.apiMainObj.selectedShippingAddress.city?this.apiService.apiMainObj.selectedShippingAddress.city:'',
        "shippingContactCompany": this.apiService.apiMainObj.selectedShippingAddress.companyName?this.apiService.apiMainObj.selectedShippingAddress.companyName:'',
        "shippingContactEmail": this.apiService.apiMainObj.selectedShippingAddress.email?this.apiService.apiMainObj.selectedShippingAddress.email:'',
        "shippingContactFirstName": this.apiService.apiMainObj.selectedShippingAddress.firstName?this.apiService.apiMainObj.selectedShippingAddress.firstName:'',
        "shippingContactLastName": this.apiService.apiMainObj.selectedShippingAddress.lastName?this.apiService.apiMainObj.selectedShippingAddress.lastName:'',
        "shippingContactPhone": this.apiService.apiMainObj.selectedShippingAddress.phoneNumber?this.apiService.apiMainObj.selectedShippingAddress.phoneNumber:'',
        "shippingCountry": this.apiService.apiMainObj.selectedShippingAddress.country?this.apiService.apiMainObj.selectedShippingAddress.country:'',
        "shippingMethod": this.commonService.commonMainObj.shippingMethod?this.commonService.commonMainObj.shippingMethod:'',
        "shippingNotes": this.commonService.commonMainObj.shippingNotes?this.commonService.commonMainObj.shippingNotes:'',
        "shippingState": this.apiService.apiMainObj.selectedShippingAddress.state?this.apiService.apiMainObj.selectedShippingAddress.state:'',
        "shippingZip": this.apiService.apiMainObj.selectedShippingAddress.zip?this.apiService.apiMainObj.selectedShippingAddress.zip:'',
        "sierraPCBToolNo": "",
        "specifyWhichCompCanNotWashed": this.commonService.commonMainObj.listOfMpnsSelected?this.commonService.commonMainObj.listOfMpnsSelected.toString():'',
        "taxExemptCertNumber":this.commonService.commonMainObj.isNotAuthChecked?'':this.commonService.commonMainObj.taxExemptCertiNumber?this.commonService.commonMainObj.taxExemptCertiNumber:'' ,
        "taxExemptOutsideCalifornia": this.commonService.commonMainObj.isNotAuthChecked?'':this.commonService.commonMainObj.taxExemptOutsideCalifornia?this.commonService.commonMainObj.taxExemptOutsideCalifornia:'',
        "taxable": this.commonService.commonMainObj.isNotAuthChecked?'':this.commonService.commonMainObj.taxable?"1":"0",
        "whenComponentWillArrive": ""
      };
      placeOrderObj.creditCardDetails = {
        "creditCardHolderName": !this.commonService.commonMainObj.isNotAuthChecked ? this.commonService.commonMainObj.cardHolderName :''
      }
      placeOrderObj.purchasingPersonDetails = {
        "paymentPending" : this.commonService.commonMainObj.purchasingPersonDetails.paymentPending == true?'1':"0",
        "firstName": this.commonService.commonMainObj.isNotAuthChecked?this.commonService.commonMainObj.purchasingPersonDetails.firstName:'',
        "lastName": this.commonService.commonMainObj.isNotAuthChecked?this.commonService.commonMainObj.purchasingPersonDetails.lastName:'',
        "email": this.commonService.commonMainObj.isNotAuthChecked?this.commonService.commonMainObj.purchasingPersonDetails.email:'',
        "remark": this.commonService.commonMainObj.isNotAuthChecked?this.commonService.commonMainObj.purchasingPersonDetails.remarks:'NA',
      }
      placeOrderObj.placeOrder['issueDetailsList'] = this.commonService.commonMainObj.fabIssuesListArray;
      placeOrderObj.placeOrder['assemblyIssueDetailsList'] = this.commonService.commonMainObj.AsmblyIssuesListArray;
      placeOrderObj.placeOrder['bomIssueDetailsList'] = this.commonService.commonMainObj.bomIssuesListArray;
      // var formData = new FormData();
      //due to OFP-344 commected below line
      //formData.append('file', this.commonService.commonMainObj.file);
      // formData.append('placeOrder', JSON.stringify(placeOrder));
      // formData.append('creditCardDetails',JSON.stringify(creditCardDetails));
      // formData.append('purchasingPersonDetails', JSON.stringify(purchasingPersonDetails));
      // if(this.commonService.commonMainObj.isNotAuthChecked){
      //   formData.append('placeOrder', JSON.stringify(purchasingPersonDetails));
      // }else{
      //   formData.append('creditCardDetails',JSON.stringify(creditCardDetails));
      // }
      placeOrderObj.s3FieldId = (this.commonService.commonMainObj.s3FileName.split('.').slice(0, -1).join('.'))
      placeOrderObj.fileName = this.commonService.commonMainObj.uploadedFileName;
      // OFP-3990
      placeOrderObj.dashboardEntry  = {
        "activityId":this.flowActivityId,
        "activityDate":this.commonService.commonMainObj.formattedDate
      }
      this.commonService.loadingShow();
      this.apiService.placeOrder(placeOrderObj).subscribe((data:any)=>{
        if(data){
          this.commonService.loadingHide();
          this.commonService.commonMainObj.orderPlacedData = data;
          // commented below related to OFP-3991
          // var orderPlacedObj={
          //   "orderId": this.commonService.commonMainObj.orderPlacedData.orderNumber
          // }
          // this.apiService.updateDetailsToDashboard(this.flowActivityId,orderPlacedObj,'ReviewConfirmOrderPage').subscribe((resDatas)=>{
          //   console.log("updateDetailsToDashboard",resDatails);
          // });
          if(this.commonService.commonMainObj.orderPlacedData.orderNumber){
            var orderNum = (this.commonService.commonMainObj.orderPlacedData.orderNumber).split("-")[0]; 
            (document.getElementById('strParentOrder')as HTMLInputElement).value = orderNum;
            if((document.getElementById("fpIframeId")as HTMLInputElement).value !== '' && !this.commonService.commonMainObj.isNotAuthChecked){
              let fpIFrameId = (document.getElementById("fpIframeId")as HTMLInputElement).value;
              let fpTargetDomain = (document.getElementById("fpTargetDomain")as HTMLInputElement).value;
              const iframe = document.querySelector("#" + fpIFrameId) as HTMLIFrameElement | null;
                if (iframe?.contentWindow) {
                  iframe.contentWindow.postMessage("getPaymentKeys", fpTargetDomain);
                }
            }else{
              if ((document.getElementById('fpIframeId')as HTMLInputElement).value === '' || this.commonService.commonMainObj.isNotAuthChecked){
                this.router.navigateByUrl('/orderstatus');
              }
            } 
          } 
          // this.router.navigateByUrl('/orderstatus');
          // console.log("pplace data",data);

        }
      },error => {
        this.commonService.loadingHide();
        console.log("Error in placing order",error);
      });
    }
    
  }

 
  cc_format(cardNUm:any){
    // return( "XXXX-XXXX-XXXX-" + (cardNUm.toString()).substring(cardNUm.toString().length - (this.commonService.commonMainObj.selectedCreditCard.cardtype=='2'? 3 : 4))  );
  }

  to_Num(x:any){
    return( parseInt(x,10) );
  }
  to_Float(x:any){
    return( parseFloat(x) );
  }

  goToOrderDetailsPage(){
    if(this.commonService.commonMainObj.userSessionMemberId != null){
      this.commonService.sessionPortalLoad();
      setTimeout(()=>{
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{
          if(data.status == 1){
            this.commonService.commonMainObj.backToOrderDetails = true;
            this.commonService.commonMainObj.isNotAuthChecked = false;
            this.commonService.commonMainObj.paymentserviceAvailable =true;
            this.commonService.commonMainObj.hidePaymentSection = false;
            this.router.navigateByUrl('/orderDetails');
          }
        },error =>{
          console.log('Error in checking user session', error);     
        })
      },800);   
    }else{
      this.commonService.commonMainObj.backToOrderDetails = true;
      this.commonService.commonMainObj.isNotAuthChecked = false;
      this.commonService.commonMainObj.paymentserviceAvailable =true;
      this.commonService.commonMainObj.hidePaymentSection = false;
      this.router.navigateByUrl('/orderDetails'); 
    }
  }
  notAuthSelection(eve:any){
    if(this.commonService.commonMainObj.isNotAuthChecked){
      this.commonService.commonMainObj.purchasingPersonDetails.paymentPending = false;
      $('#cardName').prop("disabled", true);
      // if((document.getElementById("fpIframeId")as HTMLInputElement).value !== ''){
      //   document.getElementById('CardNumber').disabled = true;
      //   document.getElementById('ExpirationDate').disabled = true;
      //   document.getElementById('SecurityCode').disabled = true;
      // }
    }else{
      this.commonService.commonMainObj.purchasingPersonDetails.paymentPending = false;
      $('#cardName').prop("disabled", false);
      // if((document.getElementById("fpIframeId")as HTMLInputElement).value !== ''){
      //   document.getElementById('CardNumber').disabled = false;
      //   document.getElementById('ExpirationDate').disabled = false;
      //   document.getElementById('SecurityCode').disabled = false;
      // }
    }
    if(this.commonService.commonMainObj.isNotAuthChecked && (this.commonService.commonMainObj.purchasingPersonDetails.firstName == '' || this.commonService.commonMainObj.purchasingPersonDetails.firstName == undefined) && (this.commonService.commonMainObj.purchasingPersonDetails.email == '' || this.commonService.commonMainObj.purchasingPersonDetails.email == undefined)){
      this.commonService.commonMainObj.purchasingPersonDetails.firstName = this.apiService.apiMainObj.selectedBillingAddress.firstName;
      this.commonService.commonMainObj.purchasingPersonDetails.lastName = this.apiService.apiMainObj.selectedBillingAddress.lastName;
      this.commonService.commonMainObj.purchasingPersonDetails.email = this.apiService.apiMainObj.selectedBillingAddress.email;
    }
    
  }
  authAgreedCheck(eve:any){
    if(this.commonService.commonMainObj.isNotAuthChecked && this.commonService.commonMainObj.purchasingPersonDetails.paymentPending){
      $('.agree-check').removeClass('red-brd');
    }
  }

}
